<template>
  <div>
    <WechatBar v-if="visithost != 'smaco2.uestc.edu.cn'" />
    <v-app style="background: #fafafa;">
      <v-container justify-center>
        <v-layout justify-center column v-if="!loading">
          <v-card class="pa-2">
            <v-layout justify-center column>
              <div style="text-align: center;">
                <h2 style="font-size: 21px;">行人二维码</h2>
              </div>
              <div style="text-align: center" class="mt-2">
                <img :src="codeInfo" style="width:200px;height:200px" />
              </div>
              <div style="text-align: center; font-size: 14px;">
                二维码剩余有效时间{{ ttl }}秒
              </div>
            </v-layout>
            <v-layout justify-center>
              <v-btn class="primary" to="/info" tile>查看通行规则</v-btn>
            </v-layout>
          </v-card>
        </v-layout>
        <v-layout align-center class="pt-4" column style="height: 200px" v-else>
          <v-progress-circular
            color="accent"
            :value="100"
            size="50"
            indeterminate
          ></v-progress-circular>
        </v-layout>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import WechatBar from "@/components/WechatBar";
import code from "@/assets/code.png";

export default {
  components: { WechatBar },
  data: () => ({
    loading: true,
    codeInfo: code,
    visithost: location.host,
    ttl: 300
  }),
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 2000);
    setInterval(() => {
      if (this.ttl > 4) this.ttl = this.ttl - 4;
      else this.ttl = 300;
    }, 4000);
  }
};
</script>

<style scoped>
.v-btn {
  margin: 6px 8px;
}
.container {
  padding: 16px;
}
</style>
